/* jshint esnext: true */
import { APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'InputNumber';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);
    }

    init() {
        this.$el.on(EVENT.CLICK, '.js-inputnumber-plus', (event) => this.updateNumber(event, 'plus'));
        this.$el.on(EVENT.CLICK, '.js-inputnumber-minus', (event) => this.updateNumber(event, 'minus'));
    }

    updateNumber(event, type) {
        let $button = $(event.currentTarget);
        let $input = $button.siblings('.js-inputnumber');
        let value = $input.val();

        if (type == 'plus') {
            if (value < 8) {
                value++;
            } else {
                return;
            }
        } else {
            if (value > 1) {
                value--;
            } else {
                return;
            }
        }

        $input.val(value);
        $input.trigger('change');
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
